import { getUser, setUser, clearAuth, getToken } from '@/utils/auth'
const state = {
  userInfo: getUser() ? getUser() : {
    id: '',
    menus: ['home']
  },
  token: getToken(),
  menuList: [{
    name: '首页',
    key: 'home'
  }, {
    name: '文献',
    key: 'book'
  }, {
    name: '报纸',
    key: 'paper'
  }, {
    name: '古籍',
    key: 'ancient'
  }, {
    name: '知识图谱',
    key: 'knowledge'
  }, {
    name: '阅读器',
    key: 'bookView'
  },
  {
    name: '书籍详情',
    key: 'bookDetail'
  },
  {
    name: '结构详情',
    key: 'schemaDetail'
  }, {
    name: '搜索列表',
    key: 'searchList'
  }]
}
const actions = {
  async logOut ({ commit }, payload) {
    return commit('removeUserInfo')
  }
}
const mutations = {
  setUserInfo (state, userInfo) {
    state.userInfo = userInfo
    setUser(userInfo)
  },
  setUserToken (state, token) {
    state.token = token
  },
  removeUserInfo (state) {
    state.userInfo = {}
    clearAuth()
  }
}

export default {
  state,
  actions,
  mutations
}
